import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { InspectionDescriptor } from './model/inspection';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class InspectionService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'InspectionManagement',
      authService,
      config.INMSConfig
    );

  }

  public create(inspection: InspectionDescriptor): Promise<InspectionDescriptor> {
    return super.post<InspectionDescriptor>(
      new InspectionDescriptor({
        id: undefined,
        href: undefined,

        clerkId: inspection.clerkId,
        createdOn: inspection.createdOn,
        inspectionState: inspection.inspectionState,

        modified: inspection.modified,
        deleted: inspection.deleted
      }));
  }

  public getInspections(view?: View): Promise<List<InspectionDescriptor>> {
    return super.get<List<InspectionDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, inspection: InspectionDescriptor): Promise<InspectionDescriptor> {
    return super.put<InspectionDescriptor>(id, inspection);
  }

  public getById(id: string): Promise<InspectionDescriptor> {
    return super.get<InspectionDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/inspection/inspection.service.ts